module.exports = __webpack_public_path__ + "static/img/writeOffBg.592c0574.jpg";